import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { IFilterInstance } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import UpdateDateFilter from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/UpdateDateFilter/UpdateDateFilter";
import UpdateDateFilterResult from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/UpdateDateFilter/UpdateDateFilterResult";
import type {
    FindAppsDescriptionDto,
    IAppsUpdateDateDescriptionDto,
} from "app/pages/sales-intelligence/modules/find-apps-filters/types/description.dto";
import type {
    IAppsCommonFiltersDto,
    IAppsUpdateDateFilterDto,
} from "app/pages/sales-intelligence/store/find-apps/types";

function createUpdateDateFilter(description: FindAppsDescriptionDto): IFilterInstance<IAppsCommonFiltersDto> {
    return {
        key: "updateDate",
        trackingName: "App Update Date",
        title: { key: "si.find_apps.filters.updateDate.title" },
        tooltipText: { key: "si.find_apps.filters.updateDate.tooltip" },
        filter: new FilterPanelBaseFilter<IAppsUpdateDateFilterDto, IAppsUpdateDateDescriptionDto>({
            options: description.updateDate,
        }),
        filterView: UpdateDateFilter,
        filterResultView: UpdateDateFilterResult,
    };
}

export default createUpdateDateFilter;
